import React, { type ComponentProps, type FC, useMemo, useState } from 'react';
import classnames from 'classnames';
import { Truck } from 'react-bootstrap-icons';

import { useGetCartDeliveryInfo } from 'api';
import { useSelector } from 'store';

import LegacyDetails from 'pages/Product/components/Details';
import { Availability } from 'components/controls';
import WiseActionButton from 'components/wise/WiseActionButton';
import { WiseAskProductModal } from 'components/wise';
import { WiseAddToShoppingListButton } from 'components/wise';

import pdpActionStyles from 'theme/components/wise/WisePdpActionButton/WisePdpActionButton.module.scss';
import styles from 'theme/pages/wise/WiseProduct/components/WiseDetails/WiseDetails.module.scss';

export type WiseDetailsProps = ComponentProps<typeof LegacyDetails>;

const WiseDetails: FC<WiseDetailsProps> = ({ product, ...rest }) => {
  const { profile } = useSelector((state) => state.auth);
  const { currentCartId } = useSelector((state) => state.cart);
  const isOpenProfile = profile?.role === 'ROLE_OPEN_PROFILE';
  const [askOpen, setAskOpen] = useState(false);

  const { data: cartDeliveryInfoData } = useGetCartDeliveryInfo(currentCartId || 0, {
    enabled: !!currentCartId && profile?.role !== 'ROLE_OPEN_PROFILE'
  });

  const defaultUnit = useMemo(
    () => product?.product_price_full_info?.prices?.[0],
    [product]
  );

  const listQuantity = defaultUnit?.minimal_quantity || 1;

  return (
    <div className={styles.wiseDetailsRoot}>
      <LegacyDetails product={product} {...rest} />
      <div
        className={classnames(
          styles.detailsInfo,
          'StylePath-Pages-Wise-WiseProduct-components-WiseDetails-detailsInfo'
        )}>
        <div className={styles.detailsInfoItem}>
          {product.product_stock_formatted_full_info && (
            <Availability stock={product.product_stock_formatted_full_info} />
          )}
        </div>
        {cartDeliveryInfoData?.info && (
          <div className={styles.detailsInfoItem}>
            <Truck />
            {cartDeliveryInfoData.info}
          </div>
        )}
      </div>
      <div
        className={classnames(
          styles.detailsAction,
          'StylePath-Pages-Wise-WiseProduct-components-WiseDetails-detailsAction'
        )}>
        <WiseActionButton variant="print" />
        {!isOpenProfile && defaultUnit && (
          <WiseAddToShoppingListButton
            product_id={product.id}
            unit_id={defaultUnit.unit_id}
            image={product?.product_image_formatted_full_info?.images?.[0]?.thumb}
            title={product?.product_basic_full_info?.title}
            index={product?.product_basic_full_info?.index}
            currency={defaultUnit?.currency}
            quantity={listQuantity}
            unit={defaultUnit}
            triggerClassName={pdpActionStyles.actionButton}
          />
        )}
        <WiseActionButton
          variant="askProduct"
          product={product}
          onClick={() => setAskOpen(true)}
          className="StylePath-Pages-Wise-WiseProduct-components-WiseDetails-askProduct"
        />

        <WiseAskProductModal product={product} open={askOpen} onClose={() => setAskOpen(false)} />
      </div>
    </div>
  );
};

export default WiseDetails;
